import { render, staticRenderFns } from "./unauthorized.template.vue?vue&type=template&id=44dcb068&scoped=true&"
var script = {}
import style0 from "./unauthorized.template.vue?vue&type=style&index=0&id=44dcb068&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dcb068",
  null
  
)

export default component.exports